import { ChangeEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import SpinnerComponent from "../../../../Components/Loding/Spinner";

import { ListarMotivoInadimplenciaController } from "../../../../Controllers/Cobranca/MotivoInadimplencia/MotivoInadimplenciaController";
import {
    InserirContatoEfetivoController,
    ListarResultadoContatoEfetivo,
} from "../../../../Controllers/Cobranca/ResultadoContato/ResultadoContatoController";
import { IMotivoInadimplencia } from "../../../../Interfaces/Cobranca/MotivoInadimplencia/MotivoInadimplenciaInterface";
import { IResultadoContato } from "../../../../Interfaces/Cobranca/ResultadoContato/ResultadoContatoInterface";
import {
    BuscarParcelasAReceberController,
    ListarParcelasBoletosController,
} from "../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import {
    IParcelas,
    IParcelasResponse,
} from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";

import moment from "moment";
import "moment/locale/pt-br";

import "./styles.css";
import { useAtedimento } from "../../../../Context/Atendimento";
import { ACESSOS } from "../../../../Routes/Acessos";
import { useHistory } from "react-router-dom";
import SpinnerUAU from "../../../../Components/Loding/SpinnerUAU";
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { VerificaPossibilidadeCobrancaPorAtendimentoController } from "../../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import { useUserInfor } from "../../../../Context/User";
import OrSpinner from "../../../../Components/Utils/OrSpinner";

interface IContatoEfetivoProps {
    setShow: (show: boolean) => void;
    parcelasReq: IParcelas;
    ID_CASO: number;
}
interface IParcelasForm {
    checked: boolean;
    DT_PROMESSA: string;
    VL_PARCELA_REAJUSTADO: number;
}

export interface IParcelaCompleta extends IParcelasResponse, IParcelasForm { }

interface IContatoEfetivoForm {
    motivo_inadimplencia: number;
    resultado_contato: number;
    retorno: string;
    justificativa: string;
    parcelas: {
        [id: string]: IParcelasForm;
    };
    selecionarTodas: boolean;
    agruparParcelas: boolean;
    DT_VENCIMENTO: string;
}

function ContatoEfetivoSemVerificacao(props: IContatoEfetivoProps) {
    const history = useHistory();
    const {
        register,
        unregister,
        formState,
        handleSubmit,
        setValue,
        watch,
        reset,
        getValues,
    } = useForm<IContatoEfetivoForm>();
    const watcher = watch();
    const { FL_MODO_ATENDIMENTO, goToNextAtendimento } = useAtedimento();

    function geradorMascaraFinanceira(inputName: string) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            setValue(inputName, e.target.value);
        };
    }

    const { ID_CASO } = props;

    const [optionsMotivoInadimplencia, setOptionsMotivoInadimplencia] =
        useState<Array<IMotivoInadimplencia>>();
    const [optionsResultadoContato, setOptionsResultadoContato] =
        useState<Array<IResultadoContato>>();
    const {
        value: parcelas,
        execute: BuscarParcelasAReceber,
        loading,
    } = useAsyncCallback(BuscarParcelasAReceberController);
    const [SpinnerShow, setSpinnerShow] = useState(false);
    const [ButtonSpinner, setButtonSpinner] = useState(false);
    const resultadoContadoEfetivo = optionsResultadoContato?.filter(
        (option) => option.FL_ATIVO
    );
    const [atualizandoValoresUnico, setAtualizandoValoresUnico] =
        useState(false);
    //data default é a data daqui a 3 dias sem as horas e minutos
    const defaultDTPromessa = new Date();
    defaultDTPromessa.setDate(defaultDTPromessa.getDate() + 3);
    const defaultDTPromessaString = defaultDTPromessa
        .toISOString()
        .split("T")[0];

    const parcelasArray = Object.values(watcher.parcelas ?? {});

    const { OrgInfor } = useUserInfor();
    const siengeMode = OrgInfor.COD_ERP_INTEGRACAO === "SIENGE";

    const {
        execute: AtualizarValoresPorDataDePromessa,
        loading: atualizandoValoresPorDataDePromessa,
    } = useAsyncCallback(async (data: string) => {
        await ListarParcelasBoletosController({
            ...props.parcelasReq,
            DT_CALCULO: data,
        }).then((res) => {
            const parcelasBoleto = res.filter((p) =>
                parcelas?.some(
                    (p2) => p.ID_CHAVE_PARCELA === p2.ID_CHAVE_PARCELA
                )
            );
            parcelasBoleto.forEach((pb) => {
                setValue(
                    `parcelas.${pb.ID_CHAVE_PARCELA}.VL_PARCELA_REAJUSTADO`,
                    pb.ValorReaj
                );
            });
        });
    });

    const atualizarParcelaBoletoSelecionado = async (
        data: string,
        idParcela: string
    ) => {
        setAtualizandoValoresUnico(true);
        await ListarParcelasBoletosController({
            ...props.parcelasReq,
            DT_CALCULO: data,
        }).then((res) => {
            const parcelasBoleto = res.filter((p) =>
                parcelas?.some(
                    (p2) => p.ID_CHAVE_PARCELA === p2.ID_CHAVE_PARCELA
                )
            );
            const parcelaFind = parcelasBoleto.find(
                (parcela) => parcela.ID_CHAVE_PARCELA === idParcela
            );
            if (parcelaFind) {
                const valorAtualizado = parcelaFind?.ValorReaj;
                // correção para não alterar o valor do boleto para a soma de boletos agrupados quando estes
                // existem e sempre enviar o valor reajustado que é retornado com a data de cálculo enviada 


                // const valorAtualizado =
                // parcelaFind?.Boleto &&
                // new Date(data).getTime() <
                //     new Date(parcelaFind?.Boleto?.DataVenc_bol)?.getTime()
                //     ? parcelaFind?.Boleto?.ValorPar_Rea
                //     : parcelaFind?.ValorReaj;

                setValue(
                    `parcelas.${idParcela}.VL_PARCELA_REAJUSTADO`,
                    valorAtualizado
                );
            }
            setAtualizandoValoresUnico(false);
        });
    };

    useEffect(() => {
        ListarMotivoInadimplenciaController().then((res) => {
            setOptionsMotivoInadimplencia(res);
        });
        ListarResultadoContatoEfetivo().then((res) => {
            setOptionsResultadoContato(res);
        });
        BuscarParcelasAReceber(props.parcelasReq);
    }, [props.parcelasReq, BuscarParcelasAReceber]);

    function handleContatoEfetivoFormSubmit(formData: IContatoEfetivoForm) {
        const parcelasChecadas =
            parcelas?.reduce((parcelas, parcela, index) => {
                if (formData.parcelas[parcela.ID_CHAVE_PARCELA].checked) {
                    parcelas.push({
                        ...parcela,
                        ...formData.parcelas[parcela.ID_CHAVE_PARCELA],
                    });
                }
                return parcelas;
            }, [] as Array<IParcelaCompleta>) || [];
        const VL_BOLETO = parcelasChecadas.reduce(
            (total, p) => total + p.VL_PARCELA_REAJUSTADO,
            0
        );

        setButtonSpinner(true);

        InserirContatoEfetivoController(
            {
                ID_CASO_COBRANCA_RESULTADO_CONTATO: formData.resultado_contato,
                ID_CASO_COBRANCA_MOTVO_INADIMPLENCIA:
                    formData.motivo_inadimplencia,
                ID_CASO: ID_CASO,

                VL_BOLETO: String(VL_BOLETO).includes(".")
                    ? Number(VL_BOLETO.toFixed(2))
                    : VL_BOLETO,
                DT_VENCIMENTO: formData.DT_VENCIMENTO,

                Justificativa: formData.justificativa,
                parcelas: parcelasChecadas,
            },
            formData.agruparParcelas
        )
            .then(() => {
                setButtonSpinner(true);
                if (FL_MODO_ATENDIMENTO) {
                    setSpinnerShow(true);
                    goToNextAtendimento()
                        .then(() => {
                            props.setShow(false);
                        })
                        .finally(() => {
                            setSpinnerShow(false);
                        });
                } else {
                    setButtonSpinner(false);
                    props.setShow(false);
                    history.push(
                        ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.DS_PATH
                    );
                }
            })
            .catch(() => {
                setButtonSpinner(false);
                BuscarParcelasAReceber(props.parcelasReq);
            });
    }

    //Table
    const columnsCardView: Array<ColumnDescription<IParcelasResponse>> = [
        {
            dataField: "ID_CHAVE_PARCELA",
            text: "",
            isDummyField: true,
            formatter: (c, row) => <RowCardView parcela={row} />,
        },
    ];
    const columnsTableView: Array<ColumnDescription<IParcelasResponse>> = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (c, row, _, parcelasArray: Array<IParcelaCompleta>) => (
                <input
                    type="checkbox"
                    disabled={row.FL_N_NEGOCIAR}
                    className="mr-2"
                    name={`parcelas.${row.ID_CHAVE_PARCELA}.checked`}
                    ref={register()}
                    onChange={(e) => {
                        if (!e.target.checked)
                            setValue("selecionarTodas", false);
                        else {
                            if (
                                parcelasArray &&
                                parcelasArray.some((parcela) => parcela.checked)
                            ) {
                                setValue("agruparParcelas", true);
                                if (
                                    parcelasArray.every(
                                        (parcela) => parcela.checked
                                    )
                                )
                                    setValue("selecionarTodas", true);
                            }
                        }
                    }}
                />
            ),
            formatExtraData: parcelasArray,
        },
        {
            dataField: "DS_TIPO_PARCELA",
            text: "Parcela",
            formatter: (c, row) => `${c} - ${row.DS_TIPO}- ${row.NR_PARCELA}`,
        },
        {
            dataField: "DT_VENCIMENTO",
            text: "Data de Vencimento",
            formatter: (c) => {
                const data = new Date(c);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {new Date(c).toLocaleDateString()}
                    </span>
                );
            },
            formatExtraData: watcher.agruparParcelas,
        },
        {
            dataField: "VL_PARCELA_REAJUSTADO",
            text: "Valor Reajustado",
            formatter: (c, parcela) => (
                <input
                    step={0.01}
                    className="form-control"
                    defaultValue={parcela.VL_PARCELA_REAJUSTADO}
                    readOnly
                    name={`parcelas.${parcela.ID_CHAVE_PARCELA}.VL_PARCELA_REAJUSTADO`}
                    // onChange={geradorMascaraFinanceira(
                    //     `parcelas.${parcela.ID_CHAVE_PARCELA}.VL_PARCELA_REAJUSTADO`
                    // )}
                    ref={register({
                        setValueAs: (v) => Number(v),
                    })}
                />
            ),
        },
        {
            dataField: "DT_PROMESSA",
            text: "Promessa de Pagamento",
            formatter: (c, parcela, _, agruparParcelas: boolean) => (
                <input
                    type="date"
                    className="form-control"
                    defaultValue={defaultDTPromessaString}
                    name={`parcelas.${parcela.ID_CHAVE_PARCELA}.DT_PROMESSA`}
                    disabled={agruparParcelas}
                    onChange={(e) => {
                        const data = e.target.value;

                        if (data && !siengeMode) {
                            atualizarParcelaBoletoSelecionado(
                                data,
                                parcela.ID_CHAVE_PARCELA
                            );
                        }
                    }}
                    ref={register()}
                />
            ),
            formatExtraData: watcher.agruparParcelas,
        },
    ];
    function RowCardView(props: { parcela: IParcelasResponse }) {
        const { parcela } = props;
        const parcelaVencida =
            new Date(props.parcela.DT_VENCIMENTO).getTime() < Date.now();

        return (
            <div
                className={`card card-custom w-auto border-bottom border-1 border-dark ${parcela.FL_N_NEGOCIAR ? "bg-secondary" : ""
                    }`}
                key={parcela.ID_CHAVE_PARCELA}
            >
                <div className="card-body p-3 d-flex flex-row flex-wrap align-itens-center justify-content-between">
                    <div className="d-flex flex-column align-itens-center justify-content-center mb-1">
                        <h3 className="font-weight-bolder font-size-h2 d-flex align-items-center">
                            <input
                                type="checkbox"
                                id={`parcela-checkbox-${parcela.ID_CHAVE_PARCELA}`}
                                className="mr-2"
                                disabled={parcela.FL_N_NEGOCIAR}
                                name={`parcelas.${parcela.ID_CHAVE_PARCELA}.checked`}
                                ref={register()}
                                onChange={(e) => {
                                    const parcelasArray = Object.values(
                                        getValues().parcelas ?? {}
                                    );
                                    if (!e.target.checked)
                                        setValue("selecionarTodas", false);
                                    else {
                                        if (
                                            parcelasArray &&
                                            parcelasArray.filter(
                                                (parcela) => parcela.checked
                                            ).length > 1
                                        ) {
                                            setValue("agruparParcelas", true);

                                            if (
                                                parcelasArray.every(
                                                    (parcela) => parcela.checked
                                                )
                                            )
                                                setValue(
                                                    "selecionarTodas",
                                                    true
                                                );
                                        }
                                    }
                                }}
                            />
                            <label
                                className="text-dark-75 mb-0"
                                htmlFor={`parcela-checkbox-${parcela.ID_CHAVE_PARCELA}`}
                            >
                                {parcela.DS_TIPO_PARCELA} - {parcela.NR_PARCELA}
                            </label>
                        </h3>
                        <div className="d-flex flex-wrap flex-column">
                            <span className="d-block font-weight-bold">
                                Data Vencimento
                            </span>
                            <span
                                className={`label label-${parcelaVencida ? "danger" : "light-primary"
                                    } label-inline mr-2 my-1`}
                            >
                                {moment(parcela.DT_VENCIMENTO).format("ll")}
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-row flex-wrap justify-content-between mr-1">
                        <div className="mr-2">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Valor Reajustado
                            </span>
                            <div className="input-group">
                                {!parcela.FL_N_NEGOCIAR ? (
                                    <input
                                        className="form-control"
                                        defaultValue={
                                            parcela.VL_PARCELA_REAJUSTADO
                                        }
                                        readOnly
                                        name={`parcelas.${parcela.ID_CHAVE_PARCELA}.VL_PARCELA_REAJUSTADO`}
                                        onChange={geradorMascaraFinanceira(
                                            `parcelas.${parcela.ID_CHAVE_PARCELA}.VL_PARCELA_REAJUSTADO`
                                        )}
                                        ref={register({
                                            setValueAs: (v) => Number(v),
                                        })}
                                    />
                                ) : (
                                    parcela.VL_PARCELA_REAJUSTADO
                                )}
                            </div>
                        </div>
                        <div>
                            {!parcela.FL_N_NEGOCIAR && (
                                <>
                                    <span className="text-dark-50 flex-root font-weight-bold">
                                        Promessa de Pagamento
                                    </span>
                                    <input
                                        type="date"
                                        className="form-control"
                                        defaultValue={defaultDTPromessaString}
                                        name={`parcelas.${parcela.ID_CHAVE_PARCELA}.DT_PROMESSA`}
                                        disabled={watcher.agruparParcelas}
                                        onChange={(e) => {
                                            const data = e.target.value;

                                            if (data && !siengeMode) {
                                                atualizarParcelaBoletoSelecionado(
                                                    data,
                                                    parcela.ID_CHAVE_PARCELA
                                                );
                                            }
                                        }}
                                        ref={register()}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (loading) return <SpinnerComponent />;
    else if (
        optionsMotivoInadimplencia &&
        optionsResultadoContato &&
        !SpinnerShow
    ) {
        return (
            <form
                onSubmit={handleSubmit(handleContatoEfetivoFormSubmit)}
                className="row"
            >
                <div className="col-12 col-md-6 mt-2">
                    <label htmlFor="motivo_inadimplencia">
                        Motivo de Inadimplência
                    </label>
                    <select
                        name="motivo_inadimplencia"
                        className={`form-control placeholder-dark-50 ${formState.errors.motivo_inadimplencia &&
                            "is-invalid"
                            }`}
                        ref={register({
                            required: "Insira o motivo de inadimplência",
                        })}
                    >
                        <option></option>
                        {optionsMotivoInadimplencia.map((motivo, index) => (
                            <option
                                key={index}
                                value={
                                    motivo.ID_CASO_COBRANCA_MOTIVO_INADIMPLENCIA
                                }
                            >
                                {motivo.DS_MOTIVO_INADIMPLENCIA}
                            </option>
                        ))}
                    </select>
                    <div className="invalid-feedback">
                        {formState.errors.motivo_inadimplencia
                            ? formState.errors.motivo_inadimplencia.message
                            : ""}
                    </div>
                </div>
                <div className="col-12 col-md-6 mt-2">
                    <label htmlFor="resultado_contato">
                        Resultado de Contato
                    </label>
                    <select
                        name="resultado_contato"
                        className={`form-control placeholder-dark-50 ${formState.errors.resultado_contato && "is-invalid"
                            }`}
                        ref={register({
                            required: "Insira o resultado do contato",
                        })}
                    >
                        <option></option>
                        {resultadoContadoEfetivo?.map((resultado, index) => (
                            <option
                                key={index}
                                value={
                                    resultado.ID_CASO_COBRANCA_RESULTADO_CONTATO
                                }
                            >
                                {resultado.DS_RESULTADO_CONTATO}
                            </option>
                        ))}
                    </select>
                    <div className="invalid-feedback">
                        {formState.errors.resultado_contato
                            ? formState.errors.resultado_contato.message
                            : ""}
                    </div>
                </div>
                <div className="col-12 mt-4">
                    <h6>Promessa de Pagamento</h6>
                    <div>
                        Selecione as parcelas negociadas e data de pagamento
                        acordada.
                    </div>
                    <hr />
                    <div className="d-flex flex-wrap justify-content-between">
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name="selecionarTodas"
                                ref={register()}
                                id="selecionarTodas"
                                className="mr-2"
                                onChange={(e) => {
                                    parcelas
                                        ?.filter(
                                            (parcela) => !parcela.FL_N_NEGOCIAR
                                        )
                                        .forEach((parcela, index) => {
                                            setValue(
                                                `parcelas.${parcela.ID_CHAVE_PARCELA}.checked`,
                                                e.target.checked
                                            );
                                        });
                                }}
                            />
                            <label
                                className="text-dark-75 mb-0"
                                htmlFor="selecionarTodas"
                            >
                                Selecionar todas parcelas
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name="agruparParcelas"
                                ref={register()}
                                id="agruparParcelas"
                                className="mr-2"
                            />
                            <label
                                className="text-dark-75 mb-0"
                                htmlFor="agruparParcelas"
                            >
                                Agrupar parcelas
                            </label>
                        </div>
                    </div>
                    {watcher.agruparParcelas && (
                        <div className="px-2 form-row my-3">
                            <label>
                                Promessa de Pagamento
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="promessaPagamento-tooltip">
                                            Ao alterar a data de agrupamento,
                                            será feito um cálculo e atualização
                                            dos valores reajustados. Se a
                                            parcela tiver boleto gerado e não
                                            vencido, o valor deste será o novo
                                            valor reajustado.
                                        </Tooltip>
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        className="ml-2"
                                    />
                                </OverlayTrigger>
                            </label>
                            <input
                                type="date"
                                name="DT_VENCIMENTO"
                                ref={register({
                                    required:
                                        "Insira a data de promessa de pagamento",
                                })}
                                onChange={(e) => {
                                    const data = e.target.value;
                                    if (data && !siengeMode)
                                        AtualizarValoresPorDataDePromessa(data);
                                }}
                                defaultValue={defaultDTPromessaString}
                                className="form-control"
                            />
                            {atualizandoValoresPorDataDePromessa && (
                                <span className="text-warning d-flex g-3 align-items-center justify-content-center">
                                    <div>
                                        <Spinner size="sm" />
                                    </div>
                                    Atualizando valores reajustados para nova
                                    data de cálculo
                                </span>
                            )}
                        </div>
                    )}

                    <div className="parcelas-container">
                        {parcelas !== undefined ? (
                            <Table
                                columns={columnsCardView}
                                data={parcelas}
                                keyField="ID_CHAVE_PARCELA"
                                sizePerPage={parcelas.length ?? 1}
                                wrapperClasses="y-scroll maxHeight-300 mb-2"
                                bordered={false}
                                noDataIndication={() => (
                                    <div className="text-muted text-center"></div>
                                )}
                                noSearch
                                tableView={{
                                    columns: columnsTableView,
                                    onViewChange: () => {
                                        console.log("parcelas", parcelas);
                                        parcelas.forEach((p) => {
                                            unregister([
                                                `parcelas.${p.ID_CHAVE_PARCELA}.DT_PROMESSA`,
                                                `parcelas.${p.ID_CHAVE_PARCELA}.checked`,
                                                `parcelas.${p.ID_CHAVE_PARCELA}.VL_PARCELA_REAJUSTADO`,
                                            ]);
                                        });
                                        reset();
                                    },
                                }}
                            />
                        ) : (
                            <SpinnerUAU />
                        )}
                    </div>
                    {atualizandoValoresUnico && (
                        <span className="text-warning d-flex g-3 align-items-center justify-content-center">
                            <div>
                                <Spinner size="sm" />
                            </div>
                            Atualizando o valor reajustado de uma única parcela
                            para nova data de cálculo
                        </span>
                    )}
                    <div className="w-100 text-right">
                        {watcher.parcelas && (
                            <>
                                {parcelasArray.reduce((sum, parcela) => {
                                    return (
                                        sum +
                                        (parcela.checked &&
                                            typeof parcela.checked === "boolean"
                                            ? 1
                                            : 0)
                                    );
                                }, 0)}{" "}
                                parcelas selecionadas. Valor Total Selecionado:{" "}
                                {parcelasArray
                                    .reduce((sum, parcela) => {
                                        return (
                                            sum +
                                            (parcela.checked &&
                                                typeof parcela.checked === "boolean"
                                                ? parcela.VL_PARCELA_REAJUSTADO
                                                : 0)
                                        );
                                    }, 0)
                                    .toFixed(2)}
                            </>
                        )}
                    </div>
                </div>
                <textarea
                    name="justificativa"
                    className={`form-control placeholder-dark-45 mt-5 mh-100 ${formState.errors.justificativa && "is-invalid"
                        }`}
                    placeholder="Justificativa"
                    style={{ minHeight: "40px", height: "100px" }}
                    ref={register({
                        required: "Insira a justificativa",
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.justificativa
                        ? formState.errors.justificativa.message
                        : ""}
                </div>
                {ButtonSpinner ? (
                    <button
                        disabled={true}
                        type="button"
                        className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5"
                    >
                        <div className="row px-4">
                            <div className="loading-component">
                                <div
                                    className="spinner-border spinner-border-sm text-success"
                                    role="status"
                                >
                                    <span className="sr-only">
                                        Carregando...
                                    </span>
                                </div>
                            </div>
                            <div className="ml-2">Confirmar Contato</div>
                        </div>
                    </button>
                ) : (
                    <button className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5">
                        Confirmar Contato
                    </button>
                )}
            </form>
        );
    } else if (SpinnerShow) {
        return (
            <div className="mt-4">
                <SpinnerComponent />
                <div className="d-flex justify-content-center align-items-center mt-4 mr-5">
                    Buscando Próximo Atendimento
                </div>
            </div>
        );
    } else {
        return <SpinnerComponent />;
    }
}

export default function ContatoEfetivo(props: IContatoEfetivoProps) {
    const { FL_BLOQUEAR_COBRANCA_QUANDO_PROMESSA } =
        useUserInfor().Config.ConfigCobrancaDTO;

    const { value: podeCobrar, loading } = useAsyncEffect(async () => {
        if (FL_BLOQUEAR_COBRANCA_QUANDO_PROMESSA)
            return VerificaPossibilidadeCobrancaPorAtendimentoController(
                props.ID_CASO
            );
        else return true;
    }, [props.ID_CASO]);

    return podeCobrar === false && FL_BLOQUEAR_COBRANCA_QUANDO_PROMESSA ? (
        <div className="text-center w-100 text-danger">
            Não é possível realizar um contato efetivo para esse atendimento
            pois o produto vinculado possui promessa de pagamento em andamento
        </div>
    ) : (
        <OrSpinner loading={loading} spinner="capys">
            <ContatoEfetivoSemVerificacao {...props} />
        </OrSpinner>
    );
}
